import { render, staticRenderFns } from "./Ticketing.vue?vue&type=template&id=456fdc3d&"
import script from "./Ticketing.vue?vue&type=script&lang=js&"
export * from "./Ticketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports